
export default {
  props: {
    hotel: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      insights: null,
      notification: false,
    }
  },
  mounted() {
    this.getInsights()

    setInterval(() => {
      this.getInsights()
    }, 40000)
  },
  methods: {
    async getInsights() {
      try {
        await this.$axios
          .$get(
            `/v3/${this.hotel.aggregator}/hotels/${this.hotel.id}/insights`,
            {
              progress: false,
            },
          )
          .then((response) => {
            this.insights = response
            this.pushNotifications()
          })
      } catch (err) {}
    },
    pushNotifications() {
      if (this.insights.last_hour_views) {
        setTimeout(() => {
          this.insight = this.$i18n.t(
            '{count} people are viewing this hotel right now!',
            { count: this.insights.last_hour_views },
          )
          this.notification = true
        }, 5000)

        setTimeout(() => {
          this.notification = false
        }, 15000)
      }

      if (this.insights.last_reservation) {
        setTimeout(() => {
          this.insight = this.$i18n.t(
            'Last reservation for this hotel was made {time}.',
            { time: this.$moment(this.insights.last_reservation).fromNow() },
          )
          this.notification = true
        }, 25000)

        setTimeout(() => {
          this.notification = false
        }, 35000)
      }
    },
  },
}
